var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transparent-navbar"},[_c('span',{ref:"bgElement",staticClass:"background"}),_c('div',{staticClass:"navbar-inner",class:{ 'halfOpaque' : _vm.backgroundOpacity > 0.5 }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }